var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5C4.5 3.34315 5.84315 2 7.5 2H14.6716C15.4672 2 16.2303 2.31607 16.7929 2.87868L19.6213 5.70711C20.1839 6.26972 20.5 7.03278 20.5 7.82843V19C20.5 20.6569 19.1569 22 17.5 22H7.5C5.84315 22 4.5 20.6569 4.5 19V5ZM7.5 4C6.94772 4 6.5 4.44772 6.5 5V19C6.5 19.5523 6.94772 20 7.5 20H17.5C18.0523 20 18.5 19.5523 18.5 19V7.82843C18.5 7.56321 18.3946 7.30886 18.2071 7.12132L15.3787 4.29289C15.1911 4.10536 14.9368 4 14.6716 4H7.5ZM8.5 10C8.5 9.44772 8.94772 9 9.5 9H15.5C16.0523 9 16.5 9.44772 16.5 10C16.5 10.5523 16.0523 11 15.5 11H9.5C8.94772 11 8.5 10.5523 8.5 10ZM8.5 14C8.5 13.4477 8.94772 13 9.5 13H13.5C14.0523 13 14.5 13.4477 14.5 14C14.5 14.5523 14.0523 15 13.5 15H9.5C8.94772 15 8.5 14.5523 8.5 14Z",
    fill: "url(#paint0_linear_3914_22723)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3914_22723",
    x1: 12.5,
    y1: 2,
    x2: 12.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/Summary.be0dd9845f3a141215b933a94f3f2853.svg";
export { ForwardRef as ReactComponent };